// extracted by mini-css-extract-plugin
module.exports = {"light":"app_light__1wP4H","night":"app_night__rW_X-"};